import { ResourceItemHtmlProvider } from "./resource-item-html-provider.js";

export class ResourceItemHtmlProviderChefWebinars extends ResourceItemHtmlProvider {
  constructor(filterServices) {
    super(filterServices); 
  }

  getItemHtml(item, relatedMedia) {
    const contentType = item.contenttype ? item.contenttype[0] : item.contenttypes[0]
    const { CTAUrl } = item;
    const pageUrl = super.getResourceUrl(contentType);
    let resourceUrl;

    if (CTAUrl) {
      resourceUrl = CTAUrl;
    }
    else {
      resourceUrl = `${pageUrl}/${item.UrlName}`;
    }

    const startDateISO = (new Date(item.StartDate)).toISOString();
    const timeElement =  item.IsUpcomming ? `<time class="h6 -fs12 -c-darkgrey -mb2" datetime="${startDateISO}">${this.getDate(item.StartDate)}</time>`: '';
    const html = `<div class="col-4 -xl-half -l-third -m-half -s-full">
    <div class="Card -h-scale">
        <div>
            <span class="Label -wa -mb1 ${item.IsUpcomming ? "-tint-lightred" : "-tint-lightblue"}">${item.IsUpcomming ? "Upcoming" : "On-Demand"}</span>
            <h4>${this.encodeHtml(item.Title)}</h4>
            ${timeElement}
            <p class="-mb3">${this.encodeHtml(item.Summary)}</p>
            <a href="${resourceUrl}" class="HoverBox -mta -i-next">${item.IsUpcomming ? "Register" : "Watch Now"}</a>
        </div>
    </div>
</div>`;

return html;
}

getDate(utcDate){
    let date = new Date(utcDate);
    const options = { year: 'numeric', month: 'long', day: 'numeric', hour: 'numeric', minute: 'numeric' };
    return date.toLocaleDateString(undefined, options);
  }
}
